import { CLINIC_APPOINTMENT_TYPES, CLINIC_SERVICES_ITEMS_TYPES } from 'src/consumer/constants'
import { normalizeScreeningSpecialtyBucket } from 'src/consumer/helpers/screeningSpecialtyUtils'

export function isAppointmentListingItemGettingEdited(item) {
  return item?._isEditing
}

export function toggleIsEditingForApptListingItem(item) {
  return { ...item, _isEditing: !item?._isEditing }
}

export function isAppointmentListingItemGettingAdded(item) {
  return item?._isAdding
}

export function buildClinicEventsBasedOnTheDefaultTemplates(
  defaultCAppTypeTemplates,
  allCAppTypes,
) {
  return (defaultCAppTypeTemplates || []).flatMap((template) => {
    const matchedCAppTypes = (allCAppTypes || []).filter((appType) =>
      isAppTypePartOfDefTemplate(template, appType),
    )
    if (!matchedCAppTypes.length) {
      return [prepareCappTypeFromDefTemplate(template)]
    }
    return matchedCAppTypes
  })
}

function isAppTypePartOfDefTemplate(template, appType) {
  return appType?.templateId === template?.id
}

function prepareCappTypeFromDefTemplate(template) {
  let itemsType = template?.itemsType ?? CLINIC_SERVICES_ITEMS_TYPES.single.id

  if (template?.type === CLINIC_APPOINTMENT_TYPES['therapy-packages'].id) {
    itemsType = CLINIC_SERVICES_ITEMS_TYPES.bundle.id
  }
  return {
    templateId: template?.id,
    type: template?.type,
    title: template?.title,
    mode: template?.mode,
    visitType: template?.visitType,
    itemsType,
    duration: template?.duration ?? template?.durationInMins,
    targetSpecialtySlug:
      template?.type === 'screening'
        ? normalizeScreeningSpecialtyBucket(template?.targetSpecialtySlug)
        : undefined,
    clinicalAssessmentIds:
      template?.clinicalAssessmentIds ?? template?.psychAssessmentIds ?? [],
    iconId: template?.iconId ?? template?.icon ?? undefined,
  }
}
